import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../../response.js';
import { acceptJson, postJson } from '../../shared.js';

function resetPassword(apiUrl, request) {
    return _resetPassword.apply(this, arguments);
}
function _resetPassword() {
    _resetPassword = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/customers/account/password/reset`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson),
            body: JSON.stringify(request)
        })));
    });
    return _resetPassword.apply(this, arguments);
}

export { resetPassword };
//# sourceMappingURL=reset.js.map
